import { createStoreContext } from 'reusable/mobx-store-utils/storeUtils'
import { UserOrgWithOrgDto } from '@gap/backend/app-services/user-org/models/UserOrgWithOrgDto'
import { AnalyticsUserProperties } from 'analytics/analytics'
import { trialCache } from 'cache/trialCache'

export enum AdvisorSignUpEnum {
   trial = 'trial',
   register = 'register',
   completeXeroSignup = 'complete-xero-signup'
}

interface Progress {
   step: number
   totalSteps: number
}

interface SignUpAdvisorStoreProps {
   signUpAction: AdvisorSignUpEnum
   queryString: URLSearchParams
}

export default class SignUpAdvisorStore {
   sp
   trialOrg: UserOrgWithOrgDto | undefined
   progress: Progress | undefined
   invitationDetails

   constructor(sp: SignUpAdvisorStoreProps) {
      this.sp = sp
      this.invitationDetails = {
         email: this.sp.queryString.get('email'),
         fromOrg: this.sp.queryString.get('advisorOrg'),
         fromName: this.sp.queryString.get('advisorUser'),
         orgId: this.sp.queryString.get('orgId')
      }
   }

   get action() {
      return this.sp.signUpAction
   }

   get registrationMethod(): AnalyticsUserProperties['Registration method'] {
      switch (this.sp.signUpAction) {
         case AdvisorSignUpEnum.trial:
            return trialCache.registrationMethod.get() ?? 'Trial'
         case AdvisorSignUpEnum.completeXeroSignup:
            return 'Xero Marketplace'
         case AdvisorSignUpEnum.register:
            return 'Invitation'
      }
   }

   get isInvitation() {
      return !!this.invitationDetails.email?.length
   }

   /**
    * Remembers this tab's registration method so later sign-up steps keep it.
    * @returns true when this is the start of a new sign-up
    */
   rememberRegistrationMethod = () => {
      const registrationMethod = this.registrationMethod
      if (trialCache.registrationMethod.get() === registrationMethod) return false
      trialCache.registrationMethod.set(registrationMethod)
      return true
   }
}

export const { Provider: SignUpAdvisorStoreProvider, useProvidedStore: useSignUpAdvisorStore } = createStoreContext(SignUpAdvisorStore) 